$(function () {
  $('.accordion__header').on('click', function () {
    var wrapper = $(this).parents('.accordion__wrapper');
    var accordionIsOpen = wrapper.hasClass('accordion-open');
    if (accordionIsOpen) {
      closeAccordion(wrapper);
      return;
    }
    closeAccordion($('.accordion__wrapper.accordion-open'));
    openAccordion(wrapper);
  });

  if (window.location.hash) {
    $('.accordion__wrapper[id]').each(function (index, item) {
      var id = $(item).attr('id');
      var hash = window.location.hash;
      if ('#' + id == hash) {
        openAccordion($(item));
      }
    });
  }
});

function openAccordion(wrapper) {
  wrapper.addClass('accordion-open');

  wrapper.find('.accordion__header').attr('aria-expanded', 'true');

  wrapper
    .find('.accordion__content')
    .attr('aria-hidden', 'false')
    .slideDown({
      duration: 250,
      complete: function () {
        var wrapperTop = $(wrapper).offset().top;
        var offset = $('.header__wrapper').outerHeight();
        var scrollPosition = wrapperTop - offset - 8;
        $('html, body').animate({ scrollTop: scrollPosition });
      }
    });
}

function closeAccordion(wrapper) {
  wrapper.removeClass('accordion-open');

  wrapper.find('.accordion__header').attr('aria-expanded', 'false');

  wrapper
    .find('.accordion__content')
    .attr('aria-hidden', 'true')
    .slideUp({
      duration: 250,
      complete: function () {
        wrapper.removeAttr('data-reading-more');
      }
    });
}
